import { Action } from "../actions/types"
import { AccountHolderType, AccountHolderActionList } from "../actions/accountHolderActions"

const initialValue: Array<AccountHolderType> = []

const accountHolderReducer = (state: Array<AccountHolderType> = initialValue, action: Action) => {
    switch (action.type) {

        case AccountHolderActionList.ADD_ACCOUNT_HOLDER:
            return [
                ...state,
                action.data,
            ]

        case AccountHolderActionList.UPDATE_ACCOUNT_HOLDER:
            const updated = [...state].slice()
            const index = updated.findIndex(u => u.id === action.data.id)

            if (index > -1) {
                updated[index] = {
                    ...action.data
                }
            }

            return updated

        case AccountHolderActionList.FETCH_ACCOUNT_HOLDER:
            return action.data

        case AccountHolderActionList.DELETE_ACCOUNT_HOLDER:
            return state.filter(s => s.id !== action.data)

        default:
            return state
    }
}

export default accountHolderReducer